<template>
  <div>
    <v-dialog v-model="show" persistent scrollable max-width="800">
      <v-card>
        <v-card-title class="headline">{{ $t('components.dialog.signupCompany.createCompanyAccount') }}</v-card-title>
        <div class="font-italic pl-6 mb-3" v-html="$t('components.dialog.signupCompany.welcomeMessage')">
        </div>
        <v-card-text>
          <v-form v-model="companyValid" ref="form">
            <v-text-field
              v-model="model.company.name"
              :rules="requiredRules"
              required
              :label="$t('components.dialog.signupCompany.name')"
            ></v-text-field>
            <v-text-field
              v-model="model.company.contactName"
              :rules="requiredRules"
              required
              :label="$t('components.dialog.signupCompany.contactName')"
            ></v-text-field>
            <v-text-field
              v-model="model.company.emailPhone"
              :rules="requiredRules"
              required
              :label="$t('components.dialog.signupCompany.phoneOrEmail')"
            ></v-text-field>
            <v-textarea v-model="model.company.message" :label="$t('components.dialog.signupCompany.message')"></v-textarea>
          </v-form>

          <p class="text-error" v-if="showSignupFailedError">
            {{ $t('components.dialog.signupCompany.createAccountError') }}
          </p>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="pr-4 pb-3">
          <v-spacer></v-spacer>

          <v-btn text @click="cancel()"> {{ $t('common.cancel') }} </v-btn>

          <v-btn
            color="primary"
            class="black--text"
            :loading="sendingMail"
            :disabled="!isFormValid()"
            @click="sendContactVendorSignup()"
          >
          {{ $t('components.dialog.signupCompany.send') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { ContactUsService } from '../../services/contactus.service';

export default {
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    packetName: {
      type: String,
    }
  },

  model: {
    prop: "visible",
    event: "update"
  },

  data() {
    return {
      model: { company: {  } },
      showSignupFailedError: false,
      companyValid: false,
      companyDescriptionValid: false,
      sendingMail: false,

      //rules
      requiredRules: [
        v => !!v || this.$i18n.t('components.dialog.signupCompany.mandatory')
      ],
    };
  },

  computed: {
    show: {
      get: function() {
        return this.visible;
      },
      set: function(value) {
        this.$emit("update", value);

        if (value === false) {
          this.$emit("close");
        }
      }
    },
  },

  methods: {
    sendContactVendorSignup() {
      this.sendingMail = true;
      this.model.company.packetName = this.packetName;

      new ContactUsService()
        .sendVendorSignupMail(this.model)
        .then(() => {
          this.cancel();
        })
        .catch(err => {
          this.showSignupFailedError = true;
          this.sendingMail = false;
        });
    },

    cancel() {
      this.clearFields();
      this.showSignupFailedError = false;
      this.sendingMail = false;
      this.show = false;
    },

    clearFields() {
      this.model = { company: {  } };
      this.$refs.form.reset();
    },

    isFormValid() {
      return this.companyValid;
    },
  }
};
</script>
